import { ComponentsOverrides } from "@mui/material";

const styleOverrides: ComponentsOverrides["MuiCheckbox"] = {
  root: {
    color: "#6d9c15 !important",
    ":hover": {
      backgroundColor: "#dbfbdb !important",
    },
    ":checked": {
      color: "#6d9c15 !important",
    },
  },
};

const StyledCheckBox = {
  styleOverrides,
};

export default StyledCheckBox;
